const properties = {}

properties['0-to-3-years'] = require('./properties/0-to-3-years.png')
properties['6-years-or-older'] = require('./properties/6-years-or-older.png')
properties['12yearsoryounger'] = require('./properties/12yearsoryounger.png')
properties['100lap'] = require('./properties/100lap.png')
properties['100onlap'] = require('./properties/100onlap.png')
properties['100undersupervision'] = require('./properties/100undersupervision.png')
properties['100undersupervision16plus'] = require('./properties/100undersupervision16plus.png')
properties['100-130undersupervision'] = require('./properties/100-130undersupervision.png')
properties['100-130undersupervision16plus'] = require('./properties/100-130undersupervision16plus.png')
properties['110-120undersupervision'] = require('./properties/110-120undersupervision.png')
properties['110-120undersupervision16plus'] = require('./properties/110-120undersupervision16plus.png')
properties['110undersupervision'] = require('./properties/110undersupervision.png')
properties['110undersupervision16plus'] = require('./properties/110undersupervision16plus.png')
properties['120undersupervision'] = require('./properties/120undersupervision.png')
properties['120undersupervision16plus'] = require('./properties/120undersupervision16plus.png')
properties['accessibility-water-depth-20'] = require('./properties/accessibility-water-depth-20.png')
properties['actionphoto'] = require('./properties/actionphoto.png')
properties['anxiouseffects'] = require('./properties/anxiouseffects.png')
properties['attractionforchildren'] = require('./properties/attractionforchildren.png')
properties['attraction-reaches-heights'] = require('./properties/attraction-reaches-heights.png')
properties['assistancedogs'] = require('./properties/assistancedogs.png')
properties['attractionforfamiliy'] = require('./properties/attractionforfamiliy.png')
properties['attractionthrillseekers'] = require('./properties/attractionthrillseekers.png')
properties['babiesnotallowed'] = require('./properties/babiesnotallowed.png')
properties['babyroom'] = require('./properties/babyroom.png')
properties['babyswitch'] = require('./properties/babyswitch.png')
properties['cameras-or-selfiestick-not-allowed'] = require('./properties/cameras-or-selfiestick-not-allowed.png')
properties['childrentwelveyears'] = require('./properties/childrentwelveyears.png')
properties['childrentwelveyears2'] = require('./properties/childrentwelveyears2.png')
properties['closedduringshow'] = require('./properties/closedduringshow.png')
properties['diapervendingmachine'] = require('./properties/diapervendingmachine.png')
properties['difficultboarding'] = require('./properties/difficultboarding.png')
properties['disabledtoilet'] = require('./properties/disabledtoilet.png')
properties['dizzy'] = require('./properties/dizzy.png')
properties['easilyaccessiblewheelchairs'] = require('./properties/easilyaccessiblewheelchairs.png')
properties['entireparty'] = require('./properties/entireparty.png')
properties['entireparty2'] = require('./properties/entireparty2.png')
properties['facilities-for-impaired-hearing'] = require('./properties/facilities-for-impaired-hearing.png')
properties['flash-and-light-effects'] = require('./properties/flash-and-light-effects.png')
properties['g-forces'] = require('./properties/g-forces.png')
properties['indicatedboxes'] = require('./properties/indicatedboxes.png')
properties['indoorattraction'] = require('./properties/indoorattraction.png')
properties['injuries'] = require('./properties/injuries.png')
properties['keepdistance'] = require('./properties/keepdistance.png')
properties['leavingearlynotpossible'] = require('./properties/leavingearlynotpossible.png')
properties['leavingearlynotpossible2'] = require('./properties/leavingearlynotpossible2.png')
properties['loud-noises'] = require('./properties/loud-noises.png')
properties['mandatorydirection'] = require('./properties/mandatorydirection.png')
properties['medicalconditions'] = require('./properties/medicalconditions.png')
properties['minimum100'] = require('./properties/minimum100.png')
properties['minimum110'] = require('./properties/minimum110.png')
properties['minimum120'] = require('./properties/minimum120.png')
properties['minimum130'] = require('./properties/minimum130.png')
properties['minimum132'] = require('./properties/minimum132.png')
properties['no-dogs-allowed'] = require('./properties/no-dogs-allowed.png')
properties['no-flash-allowed'] = require('./properties/no-flash-allowed.png')
properties['no-luggage-allowed'] = require('./properties/no-luggage-allowed.png')
properties['nofacemasks'] = require('./properties/nofacemasks.png')
properties['nophysicalhelp'] = require('./properties/nophysicalhelp.png')
properties['nophysicalhelp2'] = require('./properties/nophysicalhelp2.png')
properties['no-strollers-allowed'] = require('./properties/no-strollers-allowed.png')
properties['notaccessiblewheelchairs'] = require('./properties/notaccessiblewheelchairs.png')
properties['oneperson'] = require('./properties/oneperson.png')
properties['onesupervisor'] = require('./properties/onesupervisor.png')
properties['outdoorattraction'] = require('./properties/outdoorattraction.png')
properties['partly-in-the-dark'] = require('./properties/partly-in-the-dark.png')
properties['placesallocated'] = require('./properties/placesallocated.png')
properties['pregnantwomen'] = require('./properties/pregnantwomen.png')
properties['redwhitezones'] = require('./properties/redwhitezones.png')
properties['sanitarypadsmachine'] = require('./properties/sanitarypadsmachine.png')
properties['scarfs-or-caps-not-allowed'] = require('./properties/scarfs-or-caps-not-allowed.png')
properties['selfiestick-not-allowed'] = require('./properties/selfiestick-not-allowed.png')
properties['semicoveredattraction'] = require('./properties/semicoveredattraction.png')
properties['shortentry'] = require('./properties/shortentry.png')
properties['smell-effects'] = require('./properties/smell-effects.png')
properties['smoke-and-fog-effects'] = require('./properties/smoke-and-fog-effects.png')
properties['standing-not-allowed'] = require('./properties/standing-not-allowed.png')
properties['stimuli'] = require('./properties/stimuli.png')
properties['supervision-needed'] = require('./properties/supervision-needed.png')
properties['surprising-effects'] = require('./properties/surprising-effects.png')
properties['sweat-workout'] = require('./properties/sweat-workout.png')
properties['toilets'] = require('./properties/toilets.png')
properties['toiletsmen'] = require('./properties/toiletsmen.png')
properties['toiletswomen'] = require('./properties/toiletswomen.png')
properties['transfernecessary'] = require('./properties/transfernecessary.png')
properties['underwear-mandatory'] = require('./properties/underwear-mandatory.png')
properties['visual-impairment'] = require('./properties/visual-impairment.png')
properties['wet'] = require('./properties/wet.png')
properties['waterdepth-20-35cm'] = require('./properties/waterdepth-20-35cm.png')
properties['wifi'] = require('./properties/wifi.png')

export default properties
